import { Component } from "@angular/core";

@Component({
  selector: "app-landingpage-component",
  template: `
    <div style="display: flex; align-items: center;">
      Landing page content goes here.
    </div>
  `,
})
export class LandingpageComponent {}
